import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { useMediaQuery } from "react-responsive";
import { useParams } from "react-router-dom";
import { ArrowLeft, Clock, Globe, Phone } from "react-feather";
// import moment from "moment";
import moment from "moment-timezone";
import QueryString from "qs";

import TimeSlots from "./TimeSlots";
import { authAxiosInstance } from "../../utils/axiosConfig";
import KukrejaCreativeLogo from "../../images/kukrejaCreative.png";
import KukrejaLogo from "../../images/kukrejaLogo.png";
import { decrypt, encrypt } from "../../utils/Utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAnglesDown } from "@fortawesome/free-solid-svg-icons";

const CustomerCalender = () => {
  const { customerPhone } = useParams();
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [startDate, setStartDate] = useState(null);
  const [clickDate, setClickDate] = useState(false);
  const [hideCalender, setHideCalender] = useState(false);
  const [events, setEvents] = useState([]);
  const [lunch, setLunch] = useState({});
  const [decryptPhone, setDecryptPhone] = useState(null);
  const [showScrollIcon, setShowScrollIcon] = useState(true);

  const fetchEventsForCustomer = async (selectedDate) => {
    const selectedDateTz = moment.tz(selectedDate, "Asia/Kolkata");
    const query = {
      start: {
        $gte: selectedDateTz.startOf("day").valueOf(),
        $lte: selectedDateTz.endOf("day").valueOf(),
        // $gte: moment(selectedDate).startOf("day").valueOf(),
        // $lte: moment(selectedDate).endOf("day").valueOf(),
      },
    };
    const string = QueryString.stringify(query);
    const resp = await authAxiosInstance.get(
      `/calenderEvent/forCustomer?${string}`
    );
    setEvents(resp?.data?.data);
  };

  const fetchCalenderTimes = async (date) => {
    const resp = await authAxiosInstance.get(`/calenderTimes`);
    const timesData = resp?.data?.data[0];

    const lunchStart = moment
      .tz(
        `${moment(date).format("YYYY-MM-DD")} ${timesData?.lunchStartTime}`,
        "YYYY-MM-DD HH:mm:ss",
        "Asia/Kolkata"
      )
      .toISOString();
    const lunchEnd = moment
      .tz(
        `${moment(date).format("YYYY-MM-DD")} ${timesData?.lunchEndTime}`,
        "YYYY-MM-DD HH:mm:ss",
        "Asia/Kolkata"
      )
      .toISOString();

    // const lunchStart = moment(
    //   `${moment(date).format("YYYY-MM-DD")} ${timesData?.lunchStartTime}`,
    //   "YYYY-MM-DD HH:mm:ss"
    // ).toISOString();
    // const lunchEnd = moment(
    //   `${moment(date).format("YYYY-MM-DD")} ${timesData?.lunchEndTime}`,
    //   "YYYY-MM-DD HH:mm:ss"
    // ).toISOString();

    const lunchObj = {
      type: "lunchBreak",
      title: "Lunch",
      start: lunchStart,
      end: lunchEnd,
      allDay: false,
    };
    setLunch(lunchObj);
  };

  const handleChange = (date) => {
    setStartDate(date);
    setClickDate(true);
    fetchEventsForCustomer(date);
    fetchCalenderTimes(date);
    if (isMobile) {
      setHideCalender(true);
    }
  };

  const tileDisabled = ({ date, view }) => {
    const yesterdayIST = moment()
      .tz("Asia/Kolkata")
      .subtract(1, "day")
      .startOf("day")
      .valueOf();
    // if (date < moment().subtract(1, "day").valueOf()) {
    if (date < yesterdayIST) {
      return true;
    }

    if (date.getDay() === 0) {
      return true;
    }
    return false;
  };

  const tileClassName = ({ date }) => {
    const yesterdayIST = moment()
      .tz("Asia/Kolkata")
      .subtract(1, "day")
      .startOf("day")
      .valueOf();
    if (date.getDay() === 0 || date < yesterdayIST) {
      return "disabled-tile";
    }
    // if (date.getDay() === 0 || date < moment().subtract(1, "day").valueOf()) {
    //   return "disabled-tile";
    // }
  };

  useEffect(() => {
    const decryptPhone = decrypt(customerPhone);
    console.log("decryptPhone", decryptPhone);
    setDecryptPhone(decryptPhone);
  }, [customerPhone]);

  useEffect(() => {
    if (isMobile) {
      const handelScroll = () => {
        if (window.scrollY > 100) {
          setShowScrollIcon(false);
        } else {
          setShowScrollIcon(true);
        }
      };

      window.addEventListener("scroll", handelScroll);
      return () => window.removeEventListener("scroll", handelScroll);
    }
  }, [isMobile]);

  return (
    <div
      className={`flex flex-col md:flex-row  justify-center ${
        clickDate ? "w-full md:w-[80%]" : "w-full  md:w-[60%]"
      } translate-all duration-300 md:mx-auto md:my-10 rounded-lg border bg-white calender--box-shadow relative overflow-hidden`}
    >
      <div
        className={`${hideCalender ? "hidden" : "block"} ${
          clickDate ? "w-full md:w-[40%]" : "w-full md:w-[50%]"
        } border-e`}
      >
        <div className="p-12 border-b">
          <img
            className=""
            src={KukrejaCreativeLogo}
            alt="KukrejaCreativeLogo"
          />
        </div>
        <div className="p-8 flex flex-col gap-2">
          <img
            className="w-[65px] h-[65px] text-center mx-auto md:text-left md:m-0"
            src={KukrejaLogo}
            alt="KukrejaLogo"
          />
          <p className="flex flex-row gap-1 items-center text-stone-500 text-center mx-auto md:text-left md:m-0">
            Manish S. Kukreja
          </p>
          <p className="flex flex-row gap-1 items-center text-black text-2xl mb-4 text-center mx-auto md:text-left md:m-0">
            15 Minute Meeting
          </p>
          <p className="flex flex-row gap-1 items-center text-stone-500">
            <Clock size={20} /> 15 min
          </p>
          <p className="flex flex-row gap-1 items-center text-stone-500 mb-4">
            <Phone size={20} /> Phone call
          </p>
          <p className="flex flex-row gap-1 items-center text-stone-500">
            कृपया अपनी सुविधा के अनुसार संपर्क करने के लिए तारीख और समय चुनें।
          </p>
        </div>
      </div>
      {isMobile && showScrollIcon && (
        <div className="text-right absolute bottom-[45%] right-2 z-[100]">
          <FontAwesomeIcon
            icon={faAnglesDown}
            fade
            className="text-xl"
            color="#007bff"
          />
        </div>
      )}
      <div className="p-[2px] text-center mx-auto bg-gray-600 w-[200px] h-[35px] drop-shadow-md absolute top-[2%] -right-[15%] lg:top-[5%] lg:-right-[9%] xl:top-[5%] xl:-right-[7%] transform rotate-[45deg]">
        <p className="text-[10px] text-white">Made With</p>
        <p className="text-[12px] text-white font-semibold">Love</p>
      </div>
      <div
        className={`${hideCalender ? "hidden" : "block"} ${
          clickDate ? "w-full md:w-[35%]" : "w-full md:w-[50%]"
        } translate-all duration-300 md:py-12`}
      >
        <h3 className={`pl-6 hidden text-xl md:block`}>Select a Date & Time</h3>
        <h3 className={`text-center mx-auto text-xl md:hidden`}>
          Select a Date
        </h3>
        <Calendar
          onClickDay={handleChange}
          value={startDate}
          tileDisabled={tileDisabled}
          tileClassName={tileClassName}
        />
      </div>

      {clickDate && (
        <div
          className={`w-full md:w-[25%] ${
            hideCalender ? "mt-6" : "mt-20"
          }  translate-all duration-300`}
        >
          <div
            className={` ${
              hideCalender ? "h-full" : "h-[400px]"
            } overflow-y-auto no-scrollbar px-[30px]`}
          >
            <div
              className={`${
                hideCalender ? "block" : "hidden"
              } flex flex-row justify-between mb-2`}
            >
              <h3 className={` text-xl`}>Select a Time</h3>
              <span
                className="cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  setHideCalender(false);
                  setClickDate(false);
                  setStartDate(null);
                }}
              >
                <ArrowLeft
                  color="#0056b3"
                  style={{ borderRadius: "50%", border: "2px solid #0056b3" }}
                />
              </span>
            </div>

            <TimeSlots
              selectedDate={startDate}
              events={[...events, lunch]}
              fetchEventsForCustomer={fetchEventsForCustomer}
              decryptPhone={decryptPhone}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomerCalender;
